import { useContext, useState, useEffect } from "react";
import Header from "./components/Header";
import HeroSection from "./pages/HeroSection";
import { useNetwork } from "wagmi";
import { AppContext } from "./utils";
import NetworkSwitch from "./NetworkSwitch";
import { bg } from "./components/SmallComponents/Images";
import { Box } from "@mui/material";
function App() {
  const { account } = useContext(AppContext);
  const [openNetworkSwitch, setOpenNetworkSwitch] = useState(false);
  const { chain } = useNetwork();

  useEffect(() => {
    if (account && chain && chain?.id !== 42161) {
      setOpenNetworkSwitch(true);
    }
  }, [chain, account]);
  return (
    <Box
      sx={{
        background: `
           url(${bg}) no-repeat center`,
      }}
    >
      <NetworkSwitch open={openNetworkSwitch} setOpen={setOpenNetworkSwitch} />
      <Header />
      <HeroSection />
    </Box>
  );
}

export default App;
